import apiFactory from "@/helpers/api";

const {
	post: calendarAPIPost,
	// put: calendarAPIPut,
	// del: calendarAPIDelete,
	// get: calendarAPIGet,
} = apiFactory();

export const resyncFullCalendar = () => {
	return calendarAPIPost( "/calendar/fullresync" );
};



// WEBPACK FOOTER //
// ./src/api/calendarAPI.js